export const camelCaseToTitleCase = (str) => {
    // Insert a space before any uppercase letters
    const spacedString = str.replace(/([A-Z])/g, ' $1');

    // Capitalize the first letter of each word
    const titleCaseString = spacedString.replace(/^./, (match) => match.toUpperCase());

    return titleCaseString;
};